import { Facebook, Instagram, Building2 } from "lucide-react";
import { Button } from "./ui/button";

export function Footer() {
  return (
    <footer className="bg-ink text-parchment py-16 border-t-4 border-terracotta relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-1 bg-parchment/10" />
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Logo y descripción */}
          <div className="col-span-1 md:col-span-6">
            <div className="flex items-center gap-3 mb-8 group">
              <div className="bg-terracotta p-2">
                <Building2 className="h-8 w-8 text-parchment" />
              </div>
              <div className="flex flex-col leading-none">
                <span className="text-3xl font-display font-black uppercase text-parchment">Propiedades</span>
                <span className="text-xs font-sans tracking-[0.4em] uppercase text-terracotta font-bold">LATAM Editorial</span>
              </div>
            </div>
            <p className="text-parchment/60 text-lg font-serif italic max-w-md leading-relaxed">
              Curando lo extraordinario. Redefiniendo el estándar inmobiliario en Latinoamérica a través de un diseño audaz y una curaduría impecable.
            </p>
          </div>

          {/* Enlaces rápidos */}
          <div className="col-span-1 md:col-span-3">
            <h3 className="text-xs font-black uppercase tracking-[0.3em] text-terracotta mb-6">Navegación</h3>
            <ul className="space-y-4">
              <li>
                <a href="/propiedades" className="text-parchment hover:text-terracotta text-sm uppercase font-bold tracking-widest transition-colors underline underline-offset-8 decoration-parchment/20">
                  Propiedades
                </a>
              </li>
              <li>
                <a href="/publicar" className="text-parchment hover:text-terracotta text-sm uppercase font-bold tracking-widest transition-colors underline underline-offset-8 decoration-parchment/20">
                  Publicar
                </a>
              </li>
              <li>
                <a href="/contacto" className="text-parchment hover:text-terracotta text-sm uppercase font-bold tracking-widest transition-colors underline underline-offset-8 decoration-parchment/20">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Redes sociales */}
          <div className="col-span-1 md:col-span-3">
            <h3 className="text-xs font-black uppercase tracking-[0.3em] text-terracotta mb-6">Social</h3>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/propiedadeslatam/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center border-2 border-parchment/20 hover:border-terracotta hover:bg-terracotta transition-all"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="https://www.facebook.com/propiedadeslatam" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center border-2 border-parchment/20 hover:border-terracotta hover:bg-terracotta transition-all"
              >
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-parchment/10 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-parchment/40">
            © {new Date().getFullYear()} PROPIEDADES LATAM — TODOS LOS DERECHOS RESERVADOS.
          </p>
          <div className="flex gap-8">
             <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-parchment/20 italic">Designed for Impact</span>
             <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-parchment/20 italic">Editorial v1.0</span>
          </div>
        </div>
      </div>
    </footer>
  );
} 